<div *ngIf="!appointment.isDeleted" class="document-appointment">
    <div class="appointment-card">
        <div class="appointment-card__body">
            <div class="appointment-card__details">
                <span class="appointment-card__identifier" *ngIf="!preview">
                    <icc-icon name="date"></icc-icon>
                </span>
                <div class="appointment-card__details-info">
                    <div class="appointment-card__details-row__header">
                        <span class="appointment-card__internal-index" *ngIf="!preview">
                            #{{ appointment.internalIndex }}
                        </span>

                        <span class="appointment-card__assigned-company">
                            {{ assignedCompanyName ? assignedCompanyName : 'COMPLAINT_APPOINTMENT|Brak przypisania' | translate }}
                        </span>
    
                        <span class="appointment-card__status">
                            <icc-appointment-status [status]="appointment.status"></icc-appointment-status>
                        </span>
                    </div>

                    <div class="appointment-card__details-row">
                        <span class="appointment-card__date" style="font-weight: 700;">
                            {{ appointment.date ? (appointment.date | date: 'shortDate') : 'COMPLAINT_APPOINTMENT|nieustalona data,' | translate }}
                        </span>
    
                        <span class="appointment-card__time" style="font-weight: 700;">
                            {{ appointment.time ? appointment.time : 'COMPLAINT_APPOINTMENT|nieokreślona godzina' | translate }},
                        </span>
    
                        <span class="appointment-card__person">
                            {{ appointment.assignedUserId ? getWorkerName(appointment.assignedUserId) : 'COMPLAINT_APPOINTMENT|Brak przypisania' | translate }},
                        </span>
    
                        <span class="appointment-card__scheduled-time">
                            <span>
                                {{ 'COMPLAINT_APPOINTMENT|Planowany czas:' | translate }}
                            </span>
                            <span style="font-weight: 700;">
                                {{ appointment.scheduledTime ? ('COMPLAINT_APPOINTMENT| {scheduledTime} minut' | translate: { scheduledTime: appointment.scheduledTime }) : 'INTERFACE|nieokreślony' | translate }}
                            </span>
                        </span>
    
                        <span *ngIf="appointment.timeUsed" class="appointment-card__time-used">
                            <span>
                                {{ 'COMPLAINT_APPOINTMENT|Wykorzystany czas:' | translate }}
                            </span>
                            <span style="font-weight: 700;">
                                {{ 'COMPLAINT_APPOINTMENT| {timeUsed} minut' | translate: { timeUsed: appointment.timeUsed } }}
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="appointment-card__actions" *ngIf="!preview">

                <button iccButton *ngIf="canEdit && !appointment.servicemanSignatureImage" name="protocol" (click)="editProtocol()" [appearance]="'outline'">{{ 'COMPLAINT_APPOINTMENT|Dodaj protokół' | translate }}<icc-icon name="add"></icc-icon></button>
                <button iccButton *ngIf="appointment.servicemanSignatureImage" name="protocol" (click)="viewProtocol()" [appearance]="'outline'">{{ 'COMPLAINT_APPOINTMENT|Pokaż protokół' | translate }}<icc-icon name="open"></icc-icon></button>

                <button
                    *ngIf="canEdit"
                    iccButton
                    (click)="editAppointment()"
                    [title]="'INTERFACE|Edytuj' | translate"
                    appearance="outline"
                >
                    <icc-icon name="edit"></icc-icon>
                </button>

                <button
                    *ngIf="canEdit"
                    iccButton
                    (click)="removeAppointment()"
                    [title]="'INTERFACE|Usuń' | translate"
                    appearance="outline"
                >
                    <icc-icon name="delete"></icc-icon>
                </button>
            </div>
        </div>
        <div *ngIf="appointment.comment || getAttachments('appointmentAttachment').length > 0" class="appointment-card__footer">
            <span *ngIf="appointment.comment" class="appointment-card__comment">
                {{ appointment.comment }}
            </span>
            <div *ngIf="getAttachments('appointmentAttachment').length > 0" class="appointment-card__details-row column">
                <div class="appointment-card__attachments">
                    <div class="appointment-card__attachments-body" *ngFor="let appointmentAttachment of getAttachments('appointmentAttachment'); index as i">
                        <div class="filename">
                            <a
                                *ngIf="getAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid)?.name"
                                [title]="getAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid)?.name"
                                [href]="'/complaint_attachments/' + appointmentAttachment.uuid"
                                [download]="appointmentAttachment.name"
                            >
                                {{ getAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid)?.name }}
                            </a>
                        </div>
                        <div class="description">
                            <span>{{ appointmentAttachment.description ? ('COMPLAINT|Załącznik #{no}' | translate: {no: (i + 1)}) + ' - ' + appointmentAttachment.description : ''}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
